
import XTable from 'vux/src/components/x-table/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default{
directives: {
TransferDom
},
components: {
XTable,
XDialog,
XButton,
Divider
},
data(){
return{
tabsParam:[['我的提问',"que"],['参与答疑',"finger"]],
demo:"我的提问",
nowIndex:0,//默认第一个tab为激活状态
myCourseList:[],//我的提问课程
myVideoList:[],//我的提问视频
videoQuesReply:[],//我的提问答疑详情
JoinList:[],//参与答疑课程
JoinQuesReply:[],//参与答疑详情
videoID:[],
show: false,
show1: false,
}
},
created(){

this.$nextTick(() => {

this.$vux.loading.show({
text: 'Loading'
})


this.toggleTabs(0);


setTimeout(() => {
this.$vux.loading.hide()
}, 1000)
})

},
methods:{

toggleTabs:function(index){

this.$vux.loading.show({
text: 'Loading'
})

switch(index){

case 0:
this.$api.GetMyQuestions().then((data) =>{
if(data.data.Status != 0){
return ;
}
this.myCourseList = data.data.Data.rows;
})
break;

case 1:
this.$api.GetJoinQuestions().then((data) =>{
if(data.data.Status != 0){
return ;
}
var list = data.data.Data.rows;
this.JoinList=[];
for(var item in list){
this.sortArr(list[item]);
}
})
break;
}
this.nowIndex=index;

setTimeout(() => {
this.$vux.loading.hide()
}, 300)
},

getMyVideo:function(list){

var videoID = new Array();

for(var i in list){
videoID.push(list[i].ChapterID)
}

this.$api.GetRescourse(videoID)
.then((data) => {
if(data.data.Status != 0){
return ;
}
this.myVideoList = data.data.Data;
})


var bustyle = event.target.parentElement.parentElement.nextElementSibling;

if(bustyle.className == "folding-close"){
bustyle.classList.remove("folding-close");
bustyle.classList.add("folding-show");
event.target.innerHTML = "-";
}else if(bustyle.className == "folding-show"){
bustyle.classList.remove("folding-show");
bustyle.classList.add("folding-close");
event.target.innerHTML = "+";
}

},

showDetail:function(){
this.videoQuesReply=[];
var videoID = event.target.id;
this.$api.GetVideoReply(videoID)
.then((data) => {
if(data.data.Status != 0){
return ;
}
this.videoQuesReply = data.data.Data.Rows;

this.videoID=[];
this.videoID.push(videoID);

this.show= true;
})
},

showDetail1:function(){
this.JoinQuesReply=[];
var videoID = event.target.id;
this.$api.GetJoinReply(videoID)
.then((data) => {
if(data.data.Status != 0){
return ;
}
this.JoinQuesReply = data.data.Data.rows;

this.videoID=[];
this.videoID.push(videoID);

this.show1= true;
})
},

JumpVideo() {

this.$api.GetRescourse(this.videoID)
.then((data) => {
if(data.data.Status != 0){
return;
}

this.$router.push({
path: "/Index/Course",
name: "/Index/Course",
params: {
IDCode: data.data.Data[0].CourseIDCode,
ChapterID:data.data.Data[0].ChapterID,
level1: "我的收藏/",
}
})

})







},

sortArr:function (arr) {
var list = [];
var VideoInf=[];
var VideoID = [];
var courseID =[arr[0].CourseID];

this.$api.GetCourse(courseID).then((data) => {//获取课程名
if(data.data.Status != 0){
return ;
}

var courseInf = {
ID:data.data.Data[0].IDCode,
Name:data.data.Data[0].Name
}

list.push(courseInf);



for(var i in arr){
VideoID.push(arr[i].VideoID);

}
this.$api.GetRescourse(VideoID).then((datas) => {
if(datas.data.Status != 0){
return ;
}

for(var j in datas.data.Data){
var Videodata = {
VideoID:datas.data.Data[j].ID,
VideoName:datas.data.Data[j].Name
}
VideoInf.push(Videodata)
}
list.push(VideoInf)

this.JoinList.push(list)


})




})


}
}
}



// WEBPACK FOOTER //
// ./src/views/Personal/MyQuestion.vue